__turbopack_context__.v({
  "breadcrumbs": "style-module-scss-module__pNxmCW__breadcrumbs",
  "breadcrumbsWrap": "style-module-scss-module__pNxmCW__breadcrumbsWrap",
  "content": "style-module-scss-module__pNxmCW__content",
  "title": "style-module-scss-module__pNxmCW__title",
  "wrapper": "style-module-scss-module__pNxmCW__wrapper",
});
